//Using the react library
import React from "react";
//Using the react library:
import { useEffect, useState } from "react";
//API Middle man
import useApi from "../utils/UseAPI";
// React loading spinner
import Spinner from "react-bootstrap/Spinner";
import SanitizeHref from "../utils/SanitizeHref";

function DPRForms() {
  const { error, processing, getRequest } = useApi();
  const [general, setGeneral] = useState([]);
  const [dDID, setDDID] = useState([]);
  const [bH, setBH] = useState([]);
  const [bHObjective, setBHObjective] = useState([]);
  const [sA, setSA] = useState([]);
  const [sAObjective, setSAObjective] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      const [data, status] = await getRequest(null, "document/dpr");
      if (status == 200) {
        // console.log(data.data.documents);
        FormFilter(data.data.documents);
      } else {
        console.log(error);
      }
    };
    fetchLinks();
  }, []);

  function FormFilter(formsData) {
    const generalFilter = [];
    const dDIDFilter = [];
    const bHFilter = [];
    const sAFilter = [];
    const sAObjectiveFilter = [];
    const bHObjectiveFilter = [];
    formsData.forEach((form) => {
      if (form.categoryId == 1 && form.division == "DID") {
        dDIDFilter.push(form);
      } else if (form.categoryId == 8 && form.division == "BH") {
        bHFilter.push(form);
      } else if (form.categoryId == 1 && form.division == "SA") {
        sAFilter.push(form);
      } else if (form.categoryId == 10 && form.division == "SA") {
        sAObjectiveFilter.push(form);
      } else if (form.categoryId == 9 && form.division == null) {
        generalFilter.push(form);
      } else if (form.categoryId == 2 && form.division == "BH") {
        bHObjectiveFilter.push(form);
        // console.log(bHObjectiveFilter);
      }
    });
    setGeneral(generalFilter);
    setDDID(dDIDFilter);
    setBH(bHFilter);
    setSA(sAFilter);
    setBHObjective(bHObjectiveFilter);
    setSAObjective(sAObjectiveFilter);
  }
  const BuildHref = (url) => {
    let href = "";

    const instructions =
      "Department Periodic Reports Processing Instructions.pdf";
    const noPrefix =
      url == "pi" ||
      url == "db-forms" ||
      url == "dataguide" ||
      url == "dpr-forms";

    if (noPrefix) {
      href = url;
    } else if (url == instructions) {
      href = `documents/cmhc/dpr/documents/${url}`;
    } else {
      href = `documents/cmhc/dpr/documents/${url}`;
    }
    return SanitizeHref(href);
  };

  return (
    <div className="container py-4">
        {/* 1. General Information - Multi-column Grid Layout */}
        <h2 id="general-info" className="mb-4 border-bottom pb-2">General Information</h2>
        <div className="row g-3 mb-5">
            {processing ? (
                <div className="col-12 text-center p-3">
                    <Spinner animation="border" variant="success" aria-label="Loading General Information" />
                </div>
            ) : (
                general.map((data, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4">
                        <a 
                            href={BuildHref(data.url)} 
                            className="d-block p-3 border rounded bg-light text-decoration-none hover-shadow h-100"
                        >
                            📄 {data.name}
                        </a>
                    </div>
                ))
            )}
        </div>

        <h2 className="mb-4 border-bottom pb-2">Instructions and Objectives</h2>

        {/* 2. Division Sections (DID, Mental Health, Substance Abuse) */}
        {[
            { 
                title: "Developmental and Intellectual Disabilities", 
                data: dDID, 
                objectives: [] 
            },
            { 
                title: "Mental Health", 
                data: bH, 
                objectives: bHObjective 
            },
            { 
                title: "Substance Abuse", 
                data: sA, 
                objectives: sAObjective 
            }
        ].map((division, idx) => (
            <section key={idx} className="mb-4 p-4 border rounded shadow-sm bg-white">
                <h3 className="h5 text-primary mb-3">{division.title}</h3>
                <div className="row">
                    {/* Instructions Column */}
                    <div className="col-md-6">
                        <h4 className="h6 fw-bold mb-2">Instructions</h4>
                        <ul className="list-unstyled ms-2">
                            {division.data.map((item, i) => (
                                <li key={i} className="mb-2">
                                    <a 
                                        href={SanitizeHref("/documents/cmhc/dpr/documents/" + item.url)} 
                                        className="text-decoration-none"
                                    >
                                        {item.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    
                    {/* Objectives Column - Only shows if data exists */}
                    {division.objectives.length > 0 && (
                        <div className="col-md-6 border-start ps-md-4">
                            <h4 className="h6 fw-bold mb-2">Objectives</h4>
                            <ul className="list-unstyled ms-2">
                                {division.objectives.map((item, i) => (
                                    <li key={i} className="mb-2">
                                        <a 
                                            href={SanitizeHref("/documents/cmhc/dpr/documents/" + item.url)} 
                                            className="text-decoration-none"
                                        >
                                            {item.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </section>
        ))}
    </div>
);
}

export default DPRForms;
